import React, { useRef, useState } from "react";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import "./diposit.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import Footer from "../../components/admin/footer/Footer";
import useDash from "../../assets/css/dash.module.css";
import { useCallback, useEffect } from "react";
import { fetchReseller, rechargeHistoryfunc } from "../../features/apiCalls";
import { useDispatch } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import Table from "../../components/table/Table";
import { useTranslation } from "react-i18next";
import {
  ArrowClockwise,
  FilterCircle,
  PenFill,
  PrinterFill,
  ThreeDots,
} from "react-bootstrap-icons";
import CommentEdit from "./modal/CommentEdit";
import FormatNumber from "../../components/common/NumberFormat";
import { Accordion } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import PrintReport from "../reseller/resellerModals/ReportPDF";
import { badge } from "../../components/common/Utils";
import Loader from "../../components/common/Loader";
import ResellerRecharge from "../reseller/resellerModals/ResellerRecharge";
import DataFilter from "../common/DataFilter";
import useDataState from "../../hooks/useDataState";

const Recharge = () => {
  const { t } = useTranslation();
  const componentRef = useRef();
  const dispatch = useDispatch();

  const filterInputPermission = {
    month: true,
    startCreateDate: true,
    endCreateDate: true,
    reseller: true,
    medium: true,
  };

  //---> Get filtered dataset from useDataState hook
  const { filterOptions, setFilterOption } = useDataState();

  // get user role
  const userRole = useSelector((state) => state.persistedReducer.auth.role);

  // get user data
  const userData = useSelector((state) => state.persistedReducer.auth.userData);

  // get isp owner id
  const ispOwnerId = useSelector(
    (state) => state.persistedReducer.auth?.ispOwnerId,
  );

  // get recharge history
  let rechargeHistory = useSelector((state) => state.recharge.rechargeHistory);

  // get all resellers
  const resellers = useSelector((state) => state.reseller.reseller);

  // recharge data state
  const [rechargeData, setRechargeData] = useState([]);

  var today = new Date();
  var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  firstDay.setHours(0, 0, 0, 0);
  today.setHours(23, 59, 59, 999);

  // reseller data loading state
  const [resellerLoading, setResellerLoading] = useState(false);

  // recharge history loading
  const [rechargeLoading, setRechargeLoading] = useState(false);

  // reseller id state
  const [resellerId, setResellerId] = useState();

  // recharge id state
  const [rechargeId, setRechargeId] = useState();

  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");

  // filter date state
  const [filterDate, setFilterDate] = useState(firstDay);

  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  // curr & priv date state
  const [dateStart, setStartDate] = useState(new Date());
  const [dateEnd, setEndDate] = useState(new Date());

  var selectDate = new Date(filterDate.getFullYear(), filterDate.getMonth(), 1);
  var lastDate = new Date(
    filterDate.getFullYear(),
    filterDate.getMonth() + 1,
    0,
  );

  // find select reseller
  const findName = resellers.find((item) => item?.id === resellerId);

  useEffect(() => {
    //---> @Get ispOwner reseller data
    !resellers.length &&
      fetchReseller(dispatch, ispOwnerId, setResellerLoading);
  }, [ispOwnerId]);

  useEffect(() => {
    if (filterOptions?.month !== undefined) {
      var createStart = new Date(
        filterOptions?.month?.getFullYear(),
        filterOptions?.month?.getMonth(),
        1,
      );
      var createEnd = new Date(
        filterOptions?.month?.getFullYear(),
        filterOptions?.month?.getMonth() + 1,
        0,
      );
      createEnd.setHours(23, 59, 59, 999);

      if (createEnd?.getMonth() + 1 === today.getMonth() + 1) {
        setFilterOption({
          ...filterOptions,
          startCreateDate: createStart,
          endCreateDate: today,
        });
      } else {
        setFilterOption({
          ...filterOptions,
          startCreateDate: createStart,
          endCreateDate: createEnd,
        });
      }

      rechargeHistoryfunc(
        dispatch,
        ispOwnerId,
        filterOptions?.month?.getFullYear(),
        filterOptions?.month?.getMonth() + 1,
        setRechargeLoading,
      );
    }
  }, [filterOptions?.month]);

  useEffect(() => {
    // set recharge data to state
    setRechargeData(rechargeHistory);
  }, [rechargeHistory]);

  // api calls reload handler
  const reloadHandler = () => {
    rechargeHistoryfunc(
      dispatch,
      ispOwnerId,
      filterOptions?.month?.getFullYear(),
      filterOptions?.month?.getMonth() + 1,
      setRechargeLoading,
    );
  };

  // total amount calculation (status wise)
  const getTotalRecharge = useCallback(() => {
    return rechargeData.reduce(
      (acc, currentValue) => {
        if (currentValue.paymentStatus === "paid") {
          acc.paid += currentValue.amount;
        } else if (currentValue.paymentStatus === "unpaid") {
          acc.unpaid += currentValue.amount;
        }
        return acc;
      },
      { paid: 0, unpaid: 0 },
    );
  }, [rechargeData]);

  const findResellerById = (id) =>
    resellers?.find((reseller) => reseller.id === id);

  // send to table header
  const customComponent = (
    <div
      className="displayGrid"
      style={{
        fontSize: "18px",
        fontWeight: 500,
        display: "flex",
        alignItems: "center",
      }}
    >
      <div>
        {t("paidRecharge")}:{" "}
        <strong>৳{FormatNumber(getTotalRecharge().paid)}</strong>
      </div>

      <div>
        {t("unpaidRecharge")}:{" "}
        <strong>৳{FormatNumber(getTotalRecharge().unpaid)}</strong>
      </div>
    </div>
  );

  // table column
  const columns = React.useMemo(
    () => [
      {
        width: "6%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "20%",
        Header: t("name"),
        accessor: "reseller",
        Cell: ({ cell: { value } }) => findResellerById(value)?.name ?? "",
      },
      {
        width: "10%",
        Header: t("amount"),
        accessor: "amount",
      },
      {
        width: "10%",
        Header: t("medium"),
        accessor: "medium",
      },
      {
        width: "10%",
        Header: t("status"),
        accessor: "paymentStatus",
        Cell: ({ cell: { value } }) => {
          return badge(value);
        },
      },
      {
        width: "15%",
        Header: t("date"),
        accessor: "createdAt",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("MMM DD YYYY hh:mm a");
        },
      },
      {
        width: "20%",
        Header: t("comment"),
        accessor: "comment",
      },
      {
        width: "5%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",

        Cell: ({ row: { original } }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="dropdown">
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="resellerDropdown">
                <li
                  onClick={() => {
                    setIsUpdate(true);
                    setRechargeId(original.id);
                    setResellerId(original.reseller.id);
                    setModalStatus("recharge");
                    setShow(true);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">{t("edit")}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ),
      },
    ],
    [t, resellers],
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="d-flex">
                    <h2> {t("rechargeHistory")} </h2>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="reloadBtn">
                      {rechargeLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div>

                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="addAndSettingIcon">
                      <ReactToPrint
                        documentTitle={t("billReport")}
                        trigger={() => (
                          <PrinterFill
                            title={t("print")}
                            className="addcutmButton"
                          />
                        )}
                        content={() => componentRef.current}
                      />
                    </div>
                  </div>
                </div>
              </FourGround>

              {userRole !== "collector" && (
                <FourGround>
                  <div className="mt-2">
                    <Accordion alwaysOpen activeKey={activeKeys}>
                      <Accordion.Item eventKey="filter">
                        <Accordion.Body>
                          <DataFilter
                            filterData={rechargeHistory}
                            setFilterData={setRechargeData}
                            filterOptions={filterOptions}
                            setFilterOption={setFilterOption}
                            inputPermission={filterInputPermission}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <div className="collectorWrapper pb-2">
                      <div className="table-section">
                        <Table
                          customComponent={customComponent}
                          data={rechargeData}
                          columns={columns}
                          isLoading={rechargeLoading}
                        />
                      </div>
                    </div>
                  </div>
                </FourGround>
              )}

              <Footer />
            </FontColor>
          </div>
        </div>
        <div style={{ display: "none" }}>
          <PrintReport
            currentCustomers={rechargeData}
            name={findName ? findName?.name : t("allReseller")}
            ref={componentRef}
          />
        </div>
      </div>

      {/* <CommentEdit rechargeId={rechargeId} /> */}

      {/* reseller recharge modal  */}
      {modalStatus === "recharge" && (
        <ResellerRecharge
          show={show}
          setShow={setShow}
          isUpdate={isUpdate}
          resellerId={resellerId}
          rechargeId={rechargeId}
        />
      )}
    </>
  );
};

export default Recharge;
